import WCoveringMobile from './WCoveringMobile'

export default WCoveringMobile
